@if (ldInitializedSignal$()) {
	<div class="core-app-wrapper sl-flexbox-column">
		<sl-header class="sl-flexbox-row sl-flexbox-flex-static"></sl-header>
		<div class="core-app-body">
			<router-outlet></router-outlet>
		</div>
	</div>
}
